import { render, staticRenderFns } from "./AuditTrailPortalMerchant.vue?vue&type=template&id=77d99e2c&scoped=true"
import script from "./AuditTrailPortalMerchant.vue?vue&type=script&lang=js"
export * from "./AuditTrailPortalMerchant.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailPortalMerchant.vue?vue&type=style&index=0&id=77d99e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d99e2c",
  null
  
)

export default component.exports